import Hero from "@/components/home/Hero";
import Marquee from "@/components/Marquee";
import PainPoints from "@/components/home/PainPoints";
import Bento from "@/components/home/Bento";
import Calculator from "@/components/home/Calculator";
import Pricing from "@/components/home/Pricing";
import Delivery from "@/components/home/Delivery";
import Preview from "@/components/home/Preview";
import FAQ from "@/components/home/FAQ";
import Testimonials from "@/components/home/Testimonials";
import CTABand from "@/components/home/CTABand";
import { useSEO } from "@/lib/seo";

export default function HomePage() {
  useSEO(
    "The Mechanic's Tool Kit — Admin Systems for Auto Repair Shops",
    "Battle-tested shop admin documents: intake forms, work authorizations, estimate templates, warranties, payment plans and profit calculators. Instant download from $67."
  );
  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <PainPoints />
      <Bento />
      <Calculator />
      <Pricing />
      <Delivery />
      <Preview />
      <FAQ />
      <Testimonials />
      <CTABand />
    </main>
  );
}
